/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { createEditor, Editor } from "slate";
import { withHistory } from "slate-history";
import { withReact } from "slate-react";

import { withHtml } from "./withHtml";

/**
 * Initialize a slate react editor with html pasting and undo/redo support.
 */
export const initializeViennaEditor = (): Editor => withHtml(withReact(withHistory(createEditor())));
